import { HttpRequest } from "../../../util/http";
import { userData } from "../../../util/userData";

/**
 * Tries to save new user in DB. Returns new user ID on success or false otherwise
 * @param username email valid address
 * @returns {(number|boolean)}
 */
export const addUser = (username: string) => {
    const method = 'POST';
    const data = {
        user: username,
        username: username,
        p: '',
        email: username
    }

    return HttpRequest.fetch('scripts/admin_action_alerts/user/createAlertOnly', { data, method }).then((res: any) => {
        if (res && res.id) {
            // Send notification to admins

        }
        return res;
    })
}

/**
 * Verifies if selected user is active
 * @param userID
 * @returns {(number|boolean)}
 */
export const verifyActiveUser = (userID: number) => {
    const method = 'POST';
    const data = {
        userID: userID,
    }

    return HttpRequest.fetch('scripts/admin_action_alerts/user/isActiveUser', { data, method }).then((res: any) => {
        return res;
    });
}

export const getUsers = () => {
    const project = userData.getCurrentProject();
   return userData.getUserId().then((userId) => {
       const data = { current_project: project, user_id: userId };
       const method = 'POST';
       return HttpRequest.fetch('scripts/my_alerts/get_user_list', { data, method })
         .then((res: any) => {
             let users = [];
             users.push({ id: -1, email: "Select a user", username: "Select a user" });
             res.users.forEach((user) => {
                 users.push(user);
             });
             return users;
         })
   })
}

export const getActionAlertCustomerInfo = (externalReferenceID: number) => {
    const data = { client: userData.getCurrentProject(), coachingFormID: (externalReferenceID ? externalReferenceID : 0) };
    const method = 'POST';
    return HttpRequest.fetch('scripts/alert_form/getCustomerInfo', { data, method })
        .then((res: any) => {
            let customerInfo: ICustomerInformation = { name: '', email: '', phoneNumber: '' };
            for (let [, value] of Object.entries(res)) {
                if (value['tag'].includes('phone')) {
                    customerInfo.phoneNumber = value['value'];
                }
                if (value['tag'].includes('email')) {
                    customerInfo.email = value['value'];
                }
                if (!value['tag'].includes('phone') && !value['tag'].includes('email')) {
                    customerInfo.name = value['value'];
                }
            }
            return customerInfo;
        });
}

export const getCoachingFormInfo = (externalReferenceID: number) => {
    const data = { current_project: userData.getCurrentProject(), externalDataReference: (externalReferenceID ? externalReferenceID : 0) };
    const method = 'POST';
    return HttpRequest.fetch('scripts/alert_form/get_coaching_form_info', { data, method })
        .then((res: any) => {
            return res;
        });
}

export const getAvidLabel = (avid: string) => {
    const data = { current_project: userData.getCurrentProject(), avid: (avid ? avid : '') };
    const method = 'POST';
    return HttpRequest.fetch('scripts/alert_form/get_avid_label', { data, method })
        .then((res: any) => {
            return res;
        });
}

export const verifyAvidAccess = (userId: number, avid: string) => {
    const data = { current_project: userData.getCurrentProject(), avid: (avid ? avid : ''), userId: userId };
    const method = 'POST';
    return HttpRequest.fetch('scripts/alert_form/verifyAvidAccess', { data, method })
        .then((res: any) => {
            return res;
        });
}
